import React from 'react'
import { Banner } from '../ui'

export function ErrorBanner({ error, onDismiss }) {
  if (!error) return null

  const message =
    error?.message || (typeof error === 'string' ? error : 'Something went wrong. Please refresh.')

  return (
    <Banner tone="error" dismissible onDismiss={onDismiss}>
      {message}
    </Banner>
  )
}
